<template>
  <div style="background: #fff;">
    <el-breadcrumb class="support_hearder" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Cart</el-breadcrumb-item>
      <el-breadcrumb-item>Confirm Order</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="font-size:24px;font-weight:bold;color:#000;margin:35px 0 0 132px;">Filling out after-sales information</div>
    <div style="font-size:16px;color:#8d8d8d;margin:22px 0 35px 132px;">*Required Fields</div>
    <div class="box">
      <el-form autoComplete="on"
               :model="payForm"
               :rules="payRules"
               ref="payForm"
               class="box-content">
        <el-form-item prop="poNumber" label="PO Number(optional)">
          <el-input name="poNumber" class="ipt"
                    type="text"
                    v-model="payForm.poNumber"
                    autoComplete="off"
                    placeholder="Enter Your PO Number(optional)">
          </el-input>
        </el-form-item>
        <el-form-item prop="emailAddress" label="Your Email">
          <el-input name="emailAddress" class="ipt"
                    type="text"
                    v-model="payForm.emailAddress"
                    autoComplete="off"
                    placeholder="Enter Your Email">
          </el-input>
        </el-form-item>
        <el-form-item prop="address" label="Your Shipping Address">
          <el-input name="address" class="ipt"
                    type="textarea"
                    v-model="payForm.address"
                    autoComplete="off"
                    placeholder="自动匹配">
          </el-input>
        </el-form-item>
        <a style="color:#00718c;font-size:16px;" @click="goAddress">Add new address</a>
        <el-form-item prop="shippingMethod" label="Shipping Method">
          <el-input name="shippingMethod" class="ipt"
                    type="text"
                    v-model="payForm.shippingMethod"
                    autoComplete="off"
                    placeholder="Please enter your location information to display your shipping options">
          </el-input>
        </el-form-item>
        <el-form-item prop="purchaseReference" label="Purchase Reference">
          <el-input name="purchaseReference" class="ipt"
                    type="text"
                    v-model="payForm.purchaseReference"
                    autoComplete="off"
                    style="margin-bottom:15px"
                    placeholder="Reference #Description">
          </el-input>
        </el-form-item>
        <el-form-item prop="customerNotes" label="">
          <el-input name="customerNotes" class="ipt"
                    type="textarea"
                    v-model="payForm.customerNotes"
                    autoComplete="off"
                    placeholder="Customer Notes(optional)">
          </el-input>
        </el-form-item>
        <p style="font-size:16px;font-weight:bold;color:#343434;margin-bottom:14px;">product descriptions</p>
        <div style="border:1px solid #e1e1e1;padding:0 13px 13px;font-size:16px;color:#343434;width:494px;">
          <div v-for="(item, index) in products" :key="index">
            <div style="display:flex;border-bottom:1px solid #e1e1e1;justify-content: space-between;padding:12px 0 20px 0;">
              <div>
                <p>{{ item.productName }}</p>
                <p style="margin:15px 0 6px;">Description:</p>
                <p style="max-width:310px;line-height:20px;">{{ item.remark }}</p>
              </div>
              <div>
                <p>${{ item.price }}</p>
                <p style="margin:15px 0 10px;">{{ item.num }}</p>
                <p style="font-weight:bold;">${{ item.productTotal }}</p>
              </div>
            </div>
          </div>
          <div style="text-align:right;padding:18px 0 20px 0;">
            <p>
              <span>Subtotal</span>
              <span style="width:156px;float:right;">{{ subTotal }}</span>
            </p>
            <p style="margin:15px 0;">
              <span>Shipping & Handling</span>
              <span style="width:156px;float:right;">{{ handling }}</span>
            </p>
            <p>
              <span>Total</span>
              <span style="width:156px;float:right;">{{ total }}</span>
            </p>
          </div>
        </div>
        <el-form-item style="margin:25px 0 50px">
          <a class="loginBtn a1" :loading="loading" @click="handleSumit">
            SUBMIT
          </a>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
  import { queryProductPrice, queryDefaultAddress, submitOrder } from '@/api/Persona/index' ;
    const defaultPay = {
      emailAddress: '',
      address: '',
      shippingMethod: '',
      purchaseReference: '',
      customerNotes: '',
      poNumber: '',
  };
    export default {
        name: 'Payment',
        data () {
            return {
              payForm: Object.assign({}, defaultPay),
              payRules: {
                // firstName: [{required: true, trigger: 'blur'}],
                // lastName: [{required: true, trigger: 'blur'}],
              },
              loading: false,
              sumitList: [],
              queryDefaultAddress: {},
              products: [],
              handling: '',
              subTotal: '',
              total: '',
            }
        },
        mounted() {
        },
        created() {
          this.sumitList =JSON.parse(localStorage.getItem('sumitList'));
          console.log(this.sumitList, 'this.sumitList0');
          this.getQueryDefaultAddress();
          this.getQueryProductPrice();
        },
        methods: {
          getQueryDefaultAddress() {
            queryDefaultAddress({}).then((res) => {
              console.log(res, 'queryDefaultAddress');
              this.queryDefaultAddress = res;
              this.payForm.address = res.lastName + res.firstName + ',' + res.streetAddress + res.city + res.stateSelectState + ',' + res.countryUnitedStates + res.phone;
            });
          },
          getQueryProductPrice() {
            queryProductPrice({products :this.sumitList}).then((res) => {
              console.log(res, 'queryProductPrice');
              this.products = res.products;
              this.handling = res.handling;
              this.subTotal = res.subTotal;
              this.total = res.total;
            });
          },
          handleSumit() {
            this.$refs.payForm.validate(valid => {
              if (valid) {
                this.loading = true;
                this.payForm.products = this.sumitList;
                submitOrder(this.payForm).then((res) => {
                  console.log(res, 'submitOrder');
                  this.loading = false
                  this.$router.push({name: "PersonalInformation",query:{tab:'Order History'}});
                }).catch(() => {
                  this.loading = false
                });
              } else {
                return false
              }
            })
          },
          goAddress() {
            this.$router.push({name: "PersonalInformation",query:{tab:'Address Book'}});
          },
        },
    }
</script>

<style scoped>
.support_hearder {
  height: 38px;
  line-height: 38px;
  background:#f5f5f5;
  font-size:16px;
  color:#000000;
  padding-left: 30px;
}
.box{
    height:100%;
    width:100%;
    overflow: auto;
    min-height: 100vh;
    position: relative;
  }
  .box-content {
    width:550px;
    position: absolute;
    left: 50%;
    top: 0px;
    transform: translateX(-50%);
    text-align:left;
    /* border-radius:22px; */
  }
  .ipt {
    width:520px;
  }
  ::v-deep .el-form-item__label {
    font-size:16px;
    font-weight:bold;
    color:#343434;
  }
  .loginBtn{
    width:110px;
    height:48px;
    background: #00718c;
    border-radius:6px;
    color: #ffffff;
    font-size:20px;
    font-weight:bold;
    display:block;
    text-align:center;
    line-height:48px;
  }
</style>